<template>
  <div class="view">
    <h2 v-if="mode === 'CREATE'">Créer un utilisateur</h2>
    <h2 v-if="mode === 'UPDATE'">Modifier un utilisateur</h2>

    <b-form @submit="onSubmit" @reset="onReset" v-if="show" v-bind:validated="formSubmitted">

      <b-col cols="10">

        <b-row align-h="end" v-if="mode === 'UPDATE'">
          <b-col cols="3">{{ libelles.dateCreation }} : {{ utilisateur.createdDate | formatDate }}</b-col>
        </b-row>
        <b-row align-h="end" class="mb-3">
          <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group id="input-group-username" label="Identifiant" label-for="input-username"
              label-class="typo-required-field">
              <b-form-input id="input-username" v-model="utilisateur.username" maxlength="28" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="input-group-email" label="E-mail" label-for="input-email"
              label-class="typo-required-field">
              <b-form-input id="input-email" v-model="utilisateur.email" type="email" maxlength="100"
                required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="input-group-nom" label="Nom" label-for="input-nom" label-class="typo-required-field">
              <b-form-input id="input-nom" v-model="utilisateur.nom" maxlength="50" minlength="2"
                required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="input-group-prenom" label="Prénom" label-for="input-prenom"
              label-class="typo-required-field">
              <b-form-input id="input-prenom" v-model="utilisateur.prenom" maxlength="50" minlength="2"
                required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="input-group-password" label-for="input-password" v-if="mode === 'CREATE'">
              <template v-slot:label>
                <label-custom label="Mot de passe S-Print"
                  tooltip="Ce mot de passe sert uniquement à la création du compte S-Print pour l'administrateur et ne sera pas utilisé par la suite. Il n'est en aucun cas à communiquer à l'utilisateur."
                  :required="true">
                </label-custom>
              </template>
              <b-form-input id="input-password" v-model="password" type="password" maxlength="120"
                :pattern="regexPassword" :state="validatePasswords()" required></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-passwordConfirm" label="Confirmation du mot de passe"
              label-for="input-passwordConfirm" label-class="typo-required-field" v-if="mode === 'CREATE'">
              <b-form-input id="input-passwordConfirm" v-model="passwordConfirm" type="password" maxlength="120"
                :pattern="regexPassword" :state="validatePasswords()" required></b-form-input>
              <b-form-invalid-feedback>
                Les deux mots de passe doivent correspondre
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col class="typo-warning" v-if="mode === 'CREATE'">
            <div>Le mot de passe doit respecter le format suivant :</div>
            <ul>
              <li>au moins {{ minChar }} caractères</li>
              <li>au moins une lettre minuscule</li>
              <li>au moins une lettre majuscule</li>
              <li>au moins un chiffre</li>
              <li>au moins un caractère spécial parmi <code>{{ caracteresSpeciaux }}</code></li>
            </ul>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group id="input-group-direction" label-for="input-direction">
              <template v-slot:label>
                <label-custom label="Direction prescriptrice principale" :required="false">
                </label-custom>
              </template>
              <MultiselectCustom multiple id="input-direction" :options="directions" v-model="selectedDirections"
                @change="onDirectionChange(selectedDirections)"></MultiselectCustom>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group v-if="isMultiMarche || selectedDirections.length" id="input-group-marches" label="Marchés"
              label-for="input-marches">
              <MultiselectCustom :options="marches" v-model="utilisateur.marches" :defaultLabel="'Tous les marchés'"
                id="input-marches">
              </MultiselectCustom>
            </b-form-group>
            <b-form-group v-if="!isMultiMarche && !selectedDirections.length" id="input-group-marche"
              label-for="input-marche" label="Marché">
              <AutocompleteCustom id="input-marche" :items="marcheIdsItems" v-model="utilisateur.marches[0]"
                @search="onMarcheSearch" :placeholder=libelles.selectionnerMarche>
              </AutocompleteCustom>
            </b-form-group>
            <b-row>
              <b-col class="typo-warning" v-if="formSubmitted && isUserWithoutMarche">
                Vous devez assigner un marché aux utilisateurs non administrateurs
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-form-group id="input-group-isMultiMarche" label-for="input-isMultiMarche"
              label="Utilisateur multi-marché">
              <b-form-radio-group id="input-isMultiMarche" v-model="isMultiMarche" @change="onMultiMarcheChange"
                :buttons="true" button-variant="outline-primary">
                <b-form-radio :value="false">Non</b-form-radio>
                <b-form-radio :value="true">Oui</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group id="input-group-roles"
                                  label="Rôle"
                                  label-for="input-roles"
                                  label-class="typo-required-field">
                      <MultiselectCustom :options="roles"
                                         v-model="utilisateur.roles"
                                         :defaultLabel="'Sélectionner un rôle'"
                                         :required="true"
                                         id="input-roles">
                      </MultiselectCustom>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-group-isInterneSGP" label-for="input-isInterneSGP" label="Statut utilisateur">
                      <b-form-radio-group
                          id="input-isInterneSGP"
                          v-model="utilisateur.statutUtilisateur"
                          @change="onStatutChange"
                          value="statut"
                          :buttons="true"
                          button-variant="outline-primary">
                        <b-form-radio :value="0">Interne SGP</b-form-radio>
                        <b-form-radio :value="1">Externe</b-form-radio>
                        <b-form-radio :value="2">Externe MOE</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>

        <div class="pt-2">
          <b-modal id="modal-confirm-edit" title="Modification de la fiche utilisateur" ok-title="Confirmer"
            cancel-title="Annuler" @ok="update">
            <p>Confirmez-vous la modification de cette fiche utilisateur ?</p>
          </b-modal>
          <b-button type="submit" variant="primary" @click="formSubmitted = true"
            class="boutonSelect">Soumettre</b-button>
          <b-button v-if="mode === 'CREATE'" type="reset" variant="danger" class="boutonSelect">Réinitialiser</b-button>
        </div>
      </b-col>

    </b-form>
  </div>

</template>

<script>
import UtilisateurStore from '@/stores/UtilisateurStore'
import UtilisateurDto from "../../dtos/UtilisateurDto";
import { RoleEnum } from "../../constants/enums";
import { libelles } from '../../constants/libelles';
import MarcheStore from "../../stores/MarcheStore";
import MultiselectCustom from "../../components/MultiselectCustom";
import AutocompleteCustom from "../../components/AutocompleteCustom";
import LabelCustom from "../../components/LabelCustom";
import {
  CARACTERES_SPECIAUX,
  PASSWORD_MIN_CHAR_ADMIN,
  PASSWORD_MIN_CHAR_UTILISATEUR,
  REGEX_ADMIN_PASSWORD,
  REGEX_MAIL_SGP,
  REGEX_UTILISATEUR_PASSWORD
} from "../../constants/regex";
import AlertStore from "../../stores/AlertStore";
import {
  ROLES_GPEC,
  ROLES_SECURITE,
  ROLES_EMPREINTE,
  ROLES_EFFECTIFS,
  ROLES_ADMIN
} from "../../constants/common";
import hasPermission from "../../filters/hasPermission";
import DirectionPresciptricePrincipaleStore from "@/stores/DirectionPrescriptricePrincipaleStore";
import marcheStore from "../../stores/MarcheStore";

export default {
  components: { MultiselectCustom, AutocompleteCustom, LabelCustom },
  data() {
    return {
      formSubmitted: false,
      show: true,
      caracteresSpeciaux: CARACTERES_SPECIAUX,
      password: null,
      passwordConfirm: null,
      utilisateur: new UtilisateurDto(),
      marches: [],
      marcheIdsItems: [],
      roles: Object.entries(RoleEnum).map(value => {
        return { text: value[1], value: { role: value[0] } }
      }),
      libelles: libelles,
      isMultiMarche: true,
      directions: [],
      selectedDirections: []
    }
  },
  computed: {
    mode() {
      return !this.$route.params.id ? 'CREATE' : 'UPDATE';
    },
    hasRoleAdmin() {
      return hasPermission(ROLES_ADMIN, this.utilisateur.roles.map(role => role.role));
    },
    minChar() {
      return this.hasRoleAdmin ? PASSWORD_MIN_CHAR_ADMIN : PASSWORD_MIN_CHAR_UTILISATEUR;
    },
    regexPassword() {
      return this.hasRoleAdmin ? REGEX_ADMIN_PASSWORD : REGEX_UTILISATEUR_PASSWORD;
    },
    isUserWithoutMarche() {
      return !this.hasRoleAdmin && (!this.utilisateur.marches || this.utilisateur.marches.length === 0);
    }
  },
  watch: {
    $route() {
      this.initUtilisateur();
    }
  },
  mounted() {
    MarcheStore.getAll().then(marches => {
      this.marches = marches.map(marche => {
        return { text: `${marche.reference} (${marche.libelleCourt})`, value: marche };
      });
      this.marcheIdsItems = this.marches;
      this.initUtilisateur();
    });
    DirectionPresciptricePrincipaleStore.getAll().then(
      response => this.directions = response.map(value => {
        return { text: value.libelle, value: value };
      })
    );
  },
  methods: {
    initUtilisateur() {
      this.formSubmitted = false;
      this.show = false;
      this.password = null;
      this.passwordConfirm = null;
      this.$nextTick(() => {
        this.show = true
      });
      if (this.mode === 'UPDATE') {
        UtilisateurStore.get(this.$route.params.id).then(value => {
          if (value) {
            this.utilisateur = value;
            this.setMarchesReferences();
          }
        });
      } else {
        this.utilisateur = new UtilisateurDto();
        this.isMultiMarche = false;
      }
      this.roles = Object.entries(RoleEnum).filter(role =>
      ((!ROLES_ADMIN.includes(role[0]) || hasPermission(["ADMINISTRATEUR"])) &&
        ((hasPermission(["CORRESPONDANT_SECURITE_ADMINISTRATEUR"]) && ROLES_SECURITE.includes(role[0]))
          || (hasPermission(["CORRESPONDANT_GPEC_ADMINISTRATEUR"]) && ROLES_GPEC.includes(role[0]))
          || (hasPermission(["CORRESPONDANT_EMPREINTE_ADMINISTRATEUR"]) && ROLES_EMPREINTE.includes(role[0]))
          || (hasPermission(["CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR"]) && ROLES_EFFECTIFS.includes(role[0]))
          || hasPermission(["ADMINISTRATEUR"]))
      )).map(value => {
        return { text: value[1], value: { role: value[0] } }
      })
    },
    setMarchesReferences() {
      this.isMultiMarche = this.utilisateur.marches.length > 1;
      this.utilisateur.marches = this.utilisateur.marches.map(userMarche => {
        return this.marches.find(marche => marche.value.id === userMarche.id).value;
      });
    },
    validatePasswords() {
      return this.formSubmitted ? this.password === this.passwordConfirm : null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      let hasError = this.isUserWithoutMarche;
      const regexMailSgp = RegExp(REGEX_MAIL_SGP);
      if (this.utilisateur.roles.some(role => role.role === 'ADMINISTRATEUR') && !regexMailSgp.test(this.utilisateur.email)) {
        hasError = true;
        AlertStore.pushError('Les administrateurs doivent posséder une adresse e-mail SGP');
      }
      if (!this.validatePasswords()) {
        hasError = true;
      }
      if (!hasError) {
        if (this.mode === 'CREATE') {
          this.utilisateur.password = this.password;
          UtilisateurStore.create(this.utilisateur).then(this.setMarchesReferences);
        } else {
          this.$bvModal.show('modal-confirm-edit');
        }
      }
    },
    update() {
      UtilisateurStore.update(this.utilisateur).then(this.setMarchesReferences);
    },
    onReset(evt) {
      evt.preventDefault();
      this.initUtilisateur();
    },
    onMarcheSearch(marche, isId) {
      this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
    },
    onMultiMarcheChange() {
      this.utilisateur.marches = [];
    },
    onDirectionChange(selectedDirections) {
      let accumulator = [];
      selectedDirections.forEach(direction => {
        marcheStore.getMarcheByDirPreId(direction.id).then(marches => {
          for (let i = 0; i < marches.length; ++i) {
            accumulator.push(marches[i]);
          }
        });
      });
      this.utilisateur.marches = accumulator;
    }

  }
}
</script>
<style scoped>
.boutonSelect {
  margin-right: 0.3%;
}
</style>
